import styled from "styled-components";
import { color, units } from "@m/alchemy-theme";
import { ArrowDownIcon } from "../icons/ArrowDownIcon";
import { Button } from "../button/Button.styled";
import { ActionList } from "../action-list/ActionList";
export const ScrollingActionList = styled(ActionList) `
  max-height: ${({ menuMaxHeight }) => menuMaxHeight ? (typeof menuMaxHeight === "number" ? `${menuMaxHeight}px` : menuMaxHeight) : "80vh"};
  overflow: auto;
`;
export const MenuButton = styled(Button) `
  padding-right: ${({ size }) => (size === "extraSmall" ? units(3.5) : units(4.5))};
  color: ${({ activeColorScheme, priority }) => (activeColorScheme === "alchemyBrand" && priority !== "global") ||
    (activeColorScheme !== "alchemyBrand" && (priority === "primary" || priority === "success"))
    ? color("inverse")
    : color("base")};
`;
export const ArrowIcon = styled(ArrowDownIcon) `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: ${units(0.75)};
`;
